.body { display: flex; flex-direction: column; gap: 12px; }
.lead { color: var(--tx2); }
.fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; }
.field { display: flex; flex-direction: column; gap: 4px; }
.label { font-size: 12px; color: var(--lb); }
.paste { height: 110px; padding: 10px; border: 1px dashed var(--bd); border-radius: 10px; background: var(--sub); color: var(--tx); font: inherit; resize: none; }
.tpls { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
.tplBtn { height: 30px; padding: 0 10px; border: 1px solid var(--bd); border-radius: 9px; background: var(--card); color: var(--tx); font: inherit; font-size: 12px; font-weight: var(--fw-label); cursor: pointer; white-space: nowrap; }
.tplBtn[aria-pressed='true'] { border-color: var(--pri); background: var(--pri-bg); }
.foot { display: flex; align-items: center; gap: 8px; width: 100%; }
.grow { flex-grow: 1; }
.mdFoot { display: flex; justify-content: flex-end; gap: 8px; }
.hrow { display: flex; gap: 12px; padding: 8px 0; border-top: 1px solid var(--line); }
.hat { width: 110px; flex-shrink: 0; font-size: 12px; color: var(--lb); }
@media (max-width: 767px) { .fields { grid-template-columns: minmax(0, 1fr); } }
